/* loaded by smart-asset */
export default require("./assets/cases-per-partial-tier.i.svg")